<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 29 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->
    <title>playvox_iso</title>
    <desc>Created with Sketch.</desc>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="GlobalNavigation" transform="translate(-22.000000, -29.000000)" :fill="color">
        <g id="Group-7">
          <g id="MainSideBar">
            <g id="playvox-iso" transform="translate(22.609836, 29.000000)">
              <polygon
                id="playvox_iso"
                points="24.2666667 0 14.028 16.9212315 5.69333333 3.21871251 13.9253333 3.21871251 11.8533333 6.5937625 13.72 9.65613754 19.6093333 0 0 0 14 23 28 0"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
/**
 * Component to render the playvox logo with custom color and size.
 * @displayName playvox-logo
 */

export default {
  props: {
    /**
     * String to defined color for the fill of the logo.
     * @values html colors, RGB or hexadecimal definitions.
     */
    color: {
      type: String,
      default: '#12B981'
    },
    /**
     * width size to main logo container
     * @values size in pixels
     */
    width: {
      type: String,
      default: '29px'
    },
    /**
     * height size to main logo container
     * @values size in pixels
     */
    height: {
      type: String,
      default: '23px'
    }
  }
};
</script>
